var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 19h1.262L16.498 8.763l-1.261-1.261L5 17.738V19zm-.596 1.5a.874.874 0 01-.644-.26.874.874 0 01-.26-.644v-1.733a1.801 1.801 0 01.527-1.275L16.69 3.931a1.7 1.7 0 01.501-.319c.183-.075.375-.112.575-.112.2 0 .395.036.583.107.188.07.354.184.5.34l1.22 1.236c.155.145.266.311.332.5.066.188.099.377.099.565 0 .201-.034.393-.103.576-.069.183-.178.35-.328.501L7.412 19.973a1.801 1.801 0 01-1.275.527H4.404zM15.856 8.144l-.62-.642 1.262 1.261-.642-.62z",
    fill: "currentColor"
  })));
}
SvgEdit.displayName = 'Edit';
export default SvgEdit;